var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#25f4ee;}.cls-2{fill:#fe2c55;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TikTok"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "TikTok-2",
    "data-name": "TikTok"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TikTok-3",
    "data-name": "TikTok"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.3,374.21v-4.53a34.34,34.34,0,0,0-4.75-.41,35.22,35.22,0,0,0-20.19,64.12,35.17,35.17,0,0,1,24.94-59.18Z",
    transform: "translate(-277 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.15,425.49a16.11,16.11,0,0,0,16.07-15.4V333.32h14a26.35,26.35,0,0,1-.4-4.86H382.66v76.69a16.1,16.1,0,0,1-16.07,15.51,16.27,16.27,0,0,1-7.42-1.85,16.1,16.1,0,0,0,13,6.68Zm56.28-66.12V355.1a26.2,26.2,0,0,1-14.51-4.38A26.62,26.62,0,0,0,428.43,359.37Z",
    transform: "translate(-277 -277)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TikTok-4",
    "data-name": "TikTok",
    className: "cls-2",
    d: "M413.93,350.73a26.43,26.43,0,0,1-6.57-17.44h-5.12a26.53,26.53,0,0,0,11.69,17.44Zm-47.38,37.73a16.1,16.1,0,0,0-7.42,30.35,16.06,16.06,0,0,1,13-25.49,17,17,0,0,1,4.75.75V374.55a32.82,32.82,0,0,0-4.75-.37h-.85V389a16.22,16.22,0,0,0-4.75-.56Z",
    transform: "translate(-277 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TikTok-5",
    "data-name": "TikTok",
    className: "cls-2",
    d: "M428.43,359.37v14.84a45.49,45.49,0,0,1-26.6-8.65v39a35.25,35.25,0,0,1-55.47,28.83,35.21,35.21,0,0,0,61-24V370.53A45.64,45.64,0,0,0,434,379.07V360a27.44,27.44,0,0,1-5.57-.59Z",
    transform: "translate(-277 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TikTok-6",
    "data-name": "TikTok",
    className: "cls-3",
    d: "M401.83,404.56v-39a45.51,45.51,0,0,0,26.64,8.53V359.26a26.64,26.64,0,0,1-14.55-8.53,26.57,26.57,0,0,1-11.68-17.44h-14v76.8a16.1,16.1,0,0,1-29.12,8.79,16.1,16.1,0,0,1,7.42-30.34,16.3,16.3,0,0,1,4.75.74V374.21a35.34,35.34,0,0,0-24.94,59.59,34.93,34.93,0,0,0,20.22,6A35.29,35.29,0,0,0,401.83,404.56Z",
    transform: "translate(-277 -277)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.bb75a29b68fc2e3080bd037aa06f4317.svg";
export { ForwardRef as ReactComponent };